export const CancellationWarningBeforePickup72Hours = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return (
    <div className="mt-[12px] flex justify-center text-small text-primary-gray">
      <div className="text-center">
        <p>픽업 72시간 이내의 취소는 고객센터로 문의해주세요.</p>
        <p>(* 한국시간 기준)</p>
      </div>
    </div>
  );
};
